import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import { cn } from '../../utils/cn';

const dialogOverlayVariants = cva('rocco-dialog-overlay', {
    variants: {
        variant: {
            default:
                'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-modalBackdrop bg-black/80',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const DialogOverlay = React.forwardRef<
    React.ElementRef<typeof DialogPrimitive.Overlay>,
    React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay> &
        VariantProps<typeof dialogOverlayVariants>
>(({ className, variant, ...props }, ref) => (
    <DialogPrimitive.Overlay
        ref={ref}
        className={cn(dialogOverlayVariants({ variant, className }))}
        {...props}
    />
));

DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
